import { Colors } from "../../constants";

export const DashboardIcon = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 15.25V9.75M15.25 15.25V9.75M12 15.25V12.75M6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V6.75C19.25 5.64543 18.3546 4.75 17.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MetricsIcon = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 5V10.25C11.75 11.3546 12.6454 12.25 13.75 12.25H19M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoalsIcon = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 8.75L18.25 4.75H5.75L9.75 8.75M17.25 14C17.25 16.8995 14.8995 19.25 12 19.25C9.10051 19.25 6.75 16.8995 6.75 14C6.75 11.1005 9.10051 8.75 12 8.75C14.8995 8.75 17.25 11.1005 17.25 14Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MeetingsIcon = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4.75V8.25M16 4.75V8.25M7.75 10.75H16.25M6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V8.75C19.25 7.64543 18.3546 6.75 17.25 6.75H6.75C5.64543 6.75 4.75 7.64543 4.75 8.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 14C17.8288 14 18.6802 16.1479 19.0239 17.696C19.2095 18.532 18.5333 19.25 17.6769 19.25H16.75M14.75 10.25C16.2688 10.25 17.25 9.01878 17.25 7.5C17.25 5.98122 16.2688 4.75 14.75 4.75M13.2183 19.25H5.78171C5.2172 19.25 4.77302 18.7817 4.88551 18.2285C5.19607 16.7012 6.21034 14 9.50002 14C12.7897 14 13.804 16.7012 14.1145 18.2285C14.227 18.7817 13.7828 19.25 13.2183 19.25ZM12.25 7.5C12.25 9.01878 11.0188 10.25 9.50002 10.25C7.98124 10.25 6.75002 9.01878 6.75002 7.5C6.75002 5.98122 7.98124 4.75 9.50002 4.75C11.0188 4.75 12.25 5.98122 12.25 7.5Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProfileIcon = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.205 11.25 8.74997 9.79493 8.74997 8C8.74997 6.20507 10.205 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.84748 19.25H17.1525C18.2944 19.25 19.174 18.2681 18.6407 17.2584C17.8563 15.7731 16.068 14 12 14C7.93198 14 6.14364 15.7731 5.35921 17.2584C4.82594 18.2681 5.70556 19.25 6.84748 19.25Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SettingsIcon = ({color}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M12.9355 15.5547C14.5924 15.5547 15.9355 14.2115 15.9355 12.5547C15.9355 10.8978 14.5924 9.55469 12.9355 9.55469C11.2787 9.55469 9.93555 10.8978 9.93555 12.5547C9.93555 14.2115 11.2787 15.5547 12.9355 15.5547Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6628 15.282C19.5418 15.5562 19.5057 15.8603 19.5592 16.1552C19.6127 16.4501 19.7532 16.7223 19.9628 16.9365L20.0174 16.9911C20.1864 17.1599 20.3205 17.3604 20.412 17.5812C20.5035 17.8019 20.5506 18.0385 20.5506 18.2774C20.5506 18.5164 20.5035 18.7529 20.412 18.9737C20.3205 19.1944 20.1864 19.3949 20.0174 19.5638C19.8485 19.7328 19.648 19.8669 19.4273 19.9584C19.2065 20.0499 18.9699 20.097 18.731 20.097C18.4921 20.097 18.2555 20.0499 18.0347 19.9584C17.814 19.8669 17.6135 19.7328 17.4446 19.5638L17.3901 19.5092C17.1758 19.2997 16.9037 19.1591 16.6088 19.1056C16.3139 19.0521 16.0097 19.0882 15.7355 19.2092C15.4667 19.3245 15.2373 19.5158 15.0758 19.7597C14.9143 20.0036 14.8276 20.2894 14.8265 20.582V20.7365C14.8265 21.2187 14.6349 21.6812 14.2939 22.0222C13.9529 22.3631 13.4905 22.5547 13.0083 22.5547C12.5261 22.5547 12.0636 22.3631 11.7226 22.0222C11.3817 21.6812 11.1901 21.2187 11.1901 20.7365V20.6547C11.1831 20.3538 11.0857 20.062 10.9106 19.8171C10.7355 19.5723 10.4908 19.3859 10.2083 19.282C9.93408 19.1609 9.62992 19.1248 9.33501 19.1783C9.04011 19.2318 8.76798 19.3724 8.55373 19.582L8.49918 19.6365C8.33032 19.8056 8.1298 19.9397 7.90907 20.0312C7.68835 20.1227 7.45176 20.1698 7.21282 20.1698C6.97388 20.1698 6.73729 20.1227 6.51656 20.0312C6.29584 19.9397 6.09532 19.8056 5.92646 19.6365C5.75741 19.4676 5.6233 19.2671 5.5318 19.0464C5.4403 18.8257 5.39321 18.5891 5.39321 18.3501C5.39321 18.1112 5.4403 17.8746 5.5318 17.6539C5.6233 17.4332 5.75741 17.2326 5.92646 17.0638L5.981 17.0092C6.19058 16.795 6.33117 16.5229 6.38464 16.228C6.43811 15.933 6.40202 15.6289 6.281 15.3547C6.16576 15.0858 5.97442 14.8565 5.73052 14.695C5.48662 14.5334 5.20081 14.4468 4.90827 14.4456H4.75373C4.27152 14.4456 3.80906 14.254 3.46808 13.9131C3.1271 13.5721 2.93555 13.1096 2.93555 12.6274C2.93555 12.1452 3.1271 11.6827 3.46808 11.3418C3.80906 11.0008 4.27152 10.8092 4.75373 10.8092H4.83555C5.13645 10.8022 5.42828 10.7048 5.67309 10.5297C5.9179 10.3546 6.10438 10.1099 6.20827 9.82741C6.32929 9.55322 6.36539 9.24906 6.31191 8.95415C6.25844 8.65925 6.11785 8.38712 5.90827 8.17287L5.85373 8.11832C5.68468 7.94946 5.55057 7.74894 5.45907 7.52822C5.36758 7.30749 5.32048 7.0709 5.32048 6.83196C5.32048 6.59302 5.36758 6.35643 5.45907 6.13571C5.55057 5.91498 5.68468 5.71446 5.85373 5.5456C6.02259 5.37655 6.22311 5.24244 6.44384 5.15094C6.66456 5.05944 6.90116 5.01235 7.14009 5.01235C7.37903 5.01235 7.61562 5.05944 7.83635 5.15094C8.05707 5.24244 8.2576 5.37655 8.42646 5.5456L8.481 5.60014C8.69526 5.80972 8.96738 5.95031 9.26228 6.00378C9.55719 6.05725 9.86135 6.02116 10.1355 5.90014H10.2083C10.4772 5.7849 10.7065 5.59356 10.868 5.34966C11.0295 5.10576 11.1162 4.81995 11.1174 4.52741V4.37287C11.1174 3.89066 11.3089 3.4282 11.6499 3.08722C11.9909 2.74625 12.4533 2.55469 12.9355 2.55469C13.4178 2.55469 13.8802 2.74625 14.2212 3.08722C14.5622 3.4282 14.7537 3.89066 14.7537 4.37287V4.45469C14.7549 4.74722 14.8416 5.03303 15.0031 5.27693C15.1646 5.52083 15.3939 5.71218 15.6628 5.82741C15.937 5.94843 16.2412 5.98453 16.5361 5.93106C16.831 5.87758 17.1031 5.73699 17.3174 5.52741L17.3719 5.47287C17.5408 5.30382 17.7413 5.16971 17.962 5.07822C18.1827 4.98672 18.4193 4.93962 18.6583 4.93962C18.8972 4.93962 19.1338 4.98672 19.3545 5.07822C19.5753 5.16971 19.7758 5.30382 19.9446 5.47287C20.1137 5.64173 20.2478 5.84225 20.3393 6.06298C20.4308 6.2837 20.4779 6.5203 20.4779 6.75923C20.4779 6.99817 20.4308 7.23476 20.3393 7.45549C20.2478 7.67621 20.1137 7.87674 19.9446 8.0456L19.8901 8.10014C19.6805 8.3144 19.5399 8.58652 19.4865 8.88142C19.433 9.17633 19.4691 9.48049 19.5901 9.75469V9.82741C19.7053 10.0963 19.8967 10.3256 20.1406 10.4871C20.3845 10.6487 20.6703 10.7353 20.9628 10.7365H21.1174C21.5996 10.7365 22.062 10.9281 22.403 11.269C22.744 11.61 22.9355 12.0725 22.9355 12.5547C22.9355 13.0369 22.744 13.4994 22.403 13.8403C22.062 14.1813 21.5996 14.3729 21.1174 14.3729H21.0355C20.743 14.374 20.4572 14.4607 20.2133 14.6222C19.9694 14.7838 19.7781 15.0131 19.6628 15.282Z"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LogOutIcon = ({color}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M16.9355 17.5547L21.9355 12.5547M21.9355 12.5547L16.9355 7.55469M21.9355 12.5547H9.93555M9.93555 3.55469H8.73555C7.05539 3.55469 6.21531 3.55469 5.57358 3.88167C5.00909 4.16929 4.55015 4.62823 4.26253 5.19272C3.93555 5.83445 3.93555 6.67453 3.93555 8.35469V16.7547C3.93555 18.4348 3.93555 19.2749 4.26253 19.9167C4.55015 20.4811 5.00909 20.9401 5.57358 21.2277C6.21531 21.5547 7.05539 21.5547 8.73555 21.5547H9.93555"
      stroke={color ?? Colors.Icon.DEFAULT}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
